// Özel lig sayfalarının (Junior Cup vb.) adresleri.
//
//   /juniorcup                                  varsayılan lig + sezon, anasayfa
//   /juniorcup/maclar                           varsayılan lig + sezon, diğer sayfalar
//   /juniorcup/lig/105/sezon/150/puan-durumu    başka lig ya da sezon
//   /juniorcup/haberler, /juniorcup/cezalar     yalnız bu sayfanın ligleri (sezondan bağımsız)
//
// "lig" ve "sezon" bölümleri sitenin geri kalanıyla aynıdır; üst menü kapsamı
// adresten aynı yolla okur.

export const PORTAL_PAGES = ["anasayfa", "maclar", "puan-durumu", "oyuncular", "haberler", "cezalar"];

// Sezondan bağımsız portal sayfaları: adresleri her zaman kısadır.
export const PORTAL_WIDE_PAGES = ["haberler", "cezalar"];

const idStr = (value) => (value === null || value === undefined ? "" : String(value).trim());

export const isPortalPage = (page) => PORTAL_PAGES.includes(page);

/** Portal içi sayfa adresi; varsayılan kapsamda kısa adres üretir. */
export function portalPath(portal, leagueId, seasonId, page = "anasayfa") {
  if (!portal?.slug) return "";
  const base = `/${encodeURIComponent(portal.slug)}`;
  const target = isPortalPage(page) ? page : "anasayfa";
  if (PORTAL_WIDE_PAGES.includes(target)) return `${base}/${target}`;
  const league = idStr(leagueId);
  const season = idStr(seasonId);
  const isDefault =
    (!league || league === idStr(portal.defaultLeagueId)) && (!season || season === idStr(portal.defaultSeasonId));
  if (isDefault) return target === "anasayfa" ? base : `${base}/${target}`;
  if (!league || !season) return base;
  return `${base}/lig/${encodeURIComponent(league)}/sezon/${encodeURIComponent(season)}/${target}`;
}

/** Ligin portal kaydı (il ve sezonlarıyla). */
export const findPortalLeague = (portal, leagueId) =>
  (portal?.leagues || []).find((league) => idStr(league.id) === idStr(leagueId)) || null;

/** Lig hangi portala atanmışsa onu döner. */
export const findPortalByLeague = (portals, leagueId) => {
  const id = Number(leagueId);
  if (!Number.isFinite(id)) return null;
  return (portals || []).find((portal) => (portal.leagueIds || []).map(Number).includes(id)) || null;
};

export const findPortalBySlug = (portals, slug) => {
  const key = String(slug || "").trim().toLocaleLowerCase("tr-TR");
  if (!key) return null;
  return (portals || []).find((portal) => portal.slug === key) || null;
};

/**
 * Üst menü öğesinin adresi. Kurallar ve iletişim sitenin il/lig sayfalarına
 * gider (lig adresi olduğu için yine portal temasıyla açılır).
 */
export function portalMenuHref(portal, key, { cityId, leagueId, seasonId } = {}) {
  const league = idStr(leagueId) || idStr(portal?.defaultLeagueId);
  const season = idStr(seasonId) || (league === idStr(portal?.defaultLeagueId) ? idStr(portal?.defaultSeasonId) : "");
  const leagueRecord = findPortalLeague(portal, league);
  const city = idStr(cityId) || idStr(leagueRecord?.cityId);
  const seasonFinal = season || idStr(leagueRecord?.defaultSeasonId);
  if (isPortalPage(key)) return portalPath(portal, league, seasonFinal, key);
  if (key === "kurallar") {
    return city && league && seasonFinal
      ? `/sehir/${encodeURIComponent(city)}/lig/${encodeURIComponent(league)}/sezon/${encodeURIComponent(seasonFinal)}/kurallar`
      : "";
  }
  if (key === "iletisim") return city ? `/sehir/${encodeURIComponent(city)}/iletisim` : "";
  return "";
}

/** Atanmış liglerin kimlikleri, haber/ceza süzgeci için "105,106". */
export const portalLeagueIdsParam = (portal) => (portal?.leagueIds || []).map(String).join(",");
